/* @ngInject */
export default function EscapeFilter() {
    return function (input) {
        if (input) {
            return window.encodeURIComponent(input);
        }
        return '';
    };
}
